import React from 'react';

const AuthMethodToggle = ({ activeMethod, ariaLabel, onChange, labels = ['Email', 'Mobile'] }) => (
  <div className="auth-method-toggle mb-4" role="tablist" aria-label={ariaLabel}>
    {labels.map((label) => {
      const method = label.toLowerCase();

      return (
        <button
          key={method}
          type="button"
          className={`auth-method-pill ${activeMethod === method ? 'is-active' : ''}`}
          onClick={() => onChange(method)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default AuthMethodToggle;
